module.exports = __webpack_public_path__ + "static/media/exit.99a57f33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/exit.svg
// module id = 384
// module chunks = 32